import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllInstagramPostsInDate.graphql';
import { Query, QueryallInstagramPostsInDateArgs } from '../../__generated__/globalTypes';

export const useAllInstagramPostsInDateQuery = (
  options?: QueryHookOptions<Query, QueryallInstagramPostsInDateArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallInstagramPostsInDateArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllInstagramPostsInDateLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallInstagramPostsInDateArgs>
): QueryResult<Query, QueryallInstagramPostsInDateArgs> & {
  getAllInstagramPostsInDate: LazyQueryExecFunction<Query, QueryallInstagramPostsInDateArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllInstagramPostsInDate, result] = useLazyQuery<Query, QueryallInstagramPostsInDateArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllInstagramPostsInDate, ...result };
};

export const useAllInstagramPostsInDatePromiseQuery = () => {
  const client = useApolloClient();

  const getAllInstagramPostsInDate = useCallback(
    (options?: Omit<QueryOptions<QueryallInstagramPostsInDateArgs, Query>, 'query'>) =>
      client.query<Query, QueryallInstagramPostsInDateArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllInstagramPostsInDate };
};
// Suspense Query Hooks
export const useAllInstagramPostsInDateSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryallInstagramPostsInDateArgs>
) => {
  const result = useSuspenseQuery<Query, QueryallInstagramPostsInDateArgs>(QUERY, {
    ...options
  });

  return result;
};
